import { SMSMessageDto } from '@act/shared/data-transfer-objects';
import { formatPhoneNumber } from '@act/shared/utilities';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, TableCell, Typography } from '@mui/material';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { userAppSelectors } from 'redux/slices/usersSlice';
import { HighlightableRow } from 'toolkit/tables/highlightable-row';
import { timeFormatter } from '@act/shared/utilities';
import { InlineAnchor } from 'utilities/inline-anchor';
import { useAppNavigation } from 'react-components/app/routing/routes';

interface TextRowProps {
  data: SMSMessageDto;
  openAdditionalMenu: (event, SMSMessage) => void;
}

const TextRow = ({ data, openAdditionalMenu }: TextRowProps) => {
  const { external: isIncoming } = data;

  const { toMemberPage } = useAppNavigation();

  const guideInteractableId = data?.message?.participantIds.find(
    pid => pid !== data?.message?.subjectId
  );

  const guideByInteractableId =
    userAppSelectors.useSelectUserByInteractableId(guideInteractableId);
  const guideById = userAppSelectors.useSelectUserById(
    data?.message?.userAssignedGuideId
  );

  const guideName = guideByInteractableId?.name || guideById?.name || 'Guide';

  const memberName = membersAppSelectors.useSelectMemberById(
    data?.message?.subjectId
  )?.name;

  const goToSubjejct = data?.message?.subjectId
    ? () => {
        toMemberPage(null, data.message.subjectId, {
          externalId: data.message.id,
          externalType: 'message',
        });
      }
    : null;

  let fromUser = {
    name: isIncoming ? memberName : guideName,
    action: isIncoming ? goToSubjejct : null,
  };

  let toUser = {
    name: isIncoming ? guideName : memberName,
    action: isIncoming ? null : goToSubjejct,
  };

  if (!data?.message) {
    fromUser = {
      name: isIncoming ? 'Unknown' : 'Unknown (Reema)',
      action: null,
    };
    toUser = { name: isIncoming ? 'Unknown (Reema)' : 'Unknown', action: null };
  }

  /**
   * If external === true; assign from :: else to
   */

  return (
    <HighlightableRow onClick={goToSubjejct ? () => goToSubjejct() : undefined}>
      <TableCell>
        <InlineAnchor onClick={fromUser.action}>
          <Typography variant="bodyMedium">{fromUser?.name}</Typography>
        </InlineAnchor>
        <br />
        <Typography variant="bodyLarge">
          {formatPhoneNumber(data?.from)}
        </Typography>
      </TableCell>
      <TableCell>
        <InlineAnchor onClick={toUser.action}>
          <Typography variant="bodyMedium">{toUser?.name}</Typography>
        </InlineAnchor>
        <br />
        <Typography variant="bodyMedium">
          {formatPhoneNumber(data?.to)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="bodyMedium">
          {timeFormatter.epochToHumanReadableDate({
            date: data?.createdAt,
            includeTime: true,
          })}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography
          variant="bodyLarge"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {data?.text}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <IconButton
          children={<MoreVertIcon />}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            openAdditionalMenu(e, data);
          }}
        />
      </TableCell>
    </HighlightableRow>
  );
};

export default TextRow;
